<app-navbar ></app-navbar>
<div class="app-content">
    <router-outlet></router-outlet>
</div>